<template>
  <div>
    <h1>Connection</h1>
    <p>{{ message }}</p>
    {{ $route.params }}
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "ConnectionView",
  computed: {
    message() {
      const { action } = this.$route.params;
      return action;
    },
  },
  methods: {
    updateConnection: firebase.functions().httpsCallable("updateConnection"),
  },
  created() {
    // TODO - ADD ERROR HANDLING
    console.log(this.$route.params);
    this.updateConnection(this.$route.params);
    // TODO - ACTUALLY CALL FUNCTION TO ACCEPT OR DECLINE INVITE
    // TODO - HIDE CONNECTION ID FROM REQUESTING USER
  },
};
</script>
